import { __extends } from "tslib";
import { release, warning } from '@awayfl/swf-loader';
import { EventDispatcher } from '../events/EventDispatcher';
var partialImp = function (obj, field) { return warning("[Builtins] Partial implemented " + obj.constructor.name + "::" + field); };
// Class: NativeMenuItem
var NativeMenuItem = /** @class */ (function (_super) {
    __extends(NativeMenuItem, _super);
    function NativeMenuItem() {
        var _this = _super.call(this) || this;
        _this._enabled = true;
        return _this;
    }
    Object.defineProperty(NativeMenuItem.prototype, "enabled", {
        get: function () {
            release || partialImp(this, 'get enabled');
            return this._enabled;
        },
        set: function (isSeparator) {
            isSeparator = !!isSeparator;
            release || partialImp(this, 'set enabled');
            this._enabled = isSeparator;
        },
        enumerable: true,
        configurable: true
    });
    // Called whenever the class is initialized.
    NativeMenuItem.classInitializer = null;
    // List of static symbols to link.
    NativeMenuItem.classSymbols = null; // [];
    // List of instance symbols to link.
    NativeMenuItem.instanceSymbols = null; // [];
    return NativeMenuItem;
}(EventDispatcher));
export { NativeMenuItem };
